var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "도급업체 상세" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable && _vm.parentVendorCd
                        ? _c("c-btn", {
                            attrs: {
                              label: "접속ID 변경",
                              icon: "verified_user",
                            },
                            on: { btnClicked: _vm.changePortalId },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.parentVendorCd
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.resetUrl,
                              isSubmit: _vm.isReset,
                              param: _vm.data,
                              mappingType: "PUT",
                              label: "비밀번호초기화",
                              icon: "password",
                            },
                            on: {
                              beforeAction: _vm.resetPwd,
                              btnCallback: _vm.resetPwdCallback,
                            },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "신규", icon: "add" },
                            on: { btnClicked: _vm.addVendor },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.deleteable
                        ? _c("c-btn", {
                            attrs: { label: "삭제", icon: "remove" },
                            on: { btnClicked: _vm.deleteData },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              disabled: !_vm.saveable,
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.data,
                              mappingType: _vm.saveType,
                              label: "저장",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveData,
                              btnCallback: _vm.saveCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        label: "업체명",
                        name: "vendorName",
                      },
                      model: {
                        value: _vm.data.vendorName,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "vendorName", $$v)
                        },
                        expression: "data.vendorName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        disabled: true,
                        label: "업체코드",
                        placeholder: "자동생성",
                        name: "vendorCd",
                      },
                      model: {
                        value: _vm.data.vendorCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "vendorCd", $$v)
                        },
                        expression: "data.vendorCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        bizNumberCheck: true,
                        label: "사업자번호",
                        name: "bizNo",
                      },
                      on: {
                        dataChange: (value) => {
                          _vm.data.portalId = _vm.$_.replace(value, /-/g, "")
                        },
                      },
                      model: {
                        value: _vm.data.bizNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "bizNo", $$v)
                        },
                        expression: "data.bizNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-select", {
                      attrs: {
                        codeGroupCd: "VENDOR_CLASS_CD",
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "vendorClassCd",
                        label: "업체분류",
                      },
                      model: {
                        value: _vm.data.vendorClassCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "vendorClassCd", $$v)
                        },
                        expression: "data.vendorClassCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-select", {
                      attrs: {
                        codeGroupCd: "VENDOR_TYPE_CD",
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "vendorTypeCd",
                        label: "업체유형",
                      },
                      model: {
                        value: _vm.data.vendorTypeCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "vendorTypeCd", $$v)
                        },
                        expression: "data.vendorTypeCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        label: "대표자명",
                        name: "representName",
                      },
                      model: {
                        value: _vm.data.representName,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "representName", $$v)
                        },
                        expression: "data.representName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        phoneNumberCheck: true,
                        label: "대표전화번호",
                        name: "phoneNo",
                      },
                      model: {
                        value: _vm.data.phoneNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "phoneNo", $$v)
                        },
                        expression: "data.phoneNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        label: "대표이메일",
                        name: "email",
                      },
                      model: {
                        value: _vm.data.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "email", $$v)
                        },
                        expression: "data.email",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        label: "담당자명",
                        name: "chargeName",
                      },
                      model: {
                        value: _vm.data.chargeName,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "chargeName", $$v)
                        },
                        expression: "data.chargeName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-8" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        label: "본사주소",
                        name: "address",
                      },
                      model: {
                        value: _vm.data.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "address", $$v)
                        },
                        expression: "data.address",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        isFlag: true,
                        label: "사용여부",
                        name: "useFlag",
                      },
                      model: {
                        value: _vm.data.useFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "useFlag", $$v)
                        },
                        expression: "data.useFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-multi-select", {
                      attrs: {
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        codeGroupCd: "PLANT_CD",
                        itemText: "codeName",
                        itemValue: "code",
                        label: "관련사업장",
                        name: "plantCds",
                      },
                      model: {
                        value: _vm.data.plantCds,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "plantCds", $$v)
                        },
                        expression: "data.plantCds",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "도급업체 포털정보" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        isFlag: true,
                        label: "도급업체 포털 접속여부",
                        name: "portalConnFlag",
                      },
                      model: {
                        value: _vm.data.portalConnFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "portalConnFlag", $$v)
                        },
                        expression: "data.portalConnFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        readonly: "",
                        required: _vm.data.portalConnFlag == "Y",
                        editable: _vm.editable,
                        label: "접속 ID",
                        name: "portalId",
                      },
                      model: {
                        value: _vm.data.portalId,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "portalId", $$v)
                        },
                        expression: "data.portalId",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }